// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__251GR","largestCol":"styles_largestCol__14Jbo","smallestCol":"styles_smallestCol__2bEnU"};